 const quotes = ["We build what you like!","We work for you!",'We help you get the House of your dreams!']

 export default  quotes